import { useEffect, useState } from "react";
import { Link, useNavigate, useHref } from "react-router-dom";

import { styled } from '@mui/material/styles';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Rating from '@mui/material/Rating';
import Typography from '@mui/material/Typography';
import Switch from '@mui/material/Switch';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import CircularProgress from '@mui/material/CircularProgress';
import useMediaQuery from '@mui/material/useMediaQuery';
import Tooltip from '@mui/material/Tooltip';

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';

import * as React from 'react';
import Collapse from '@mui/material/Collapse';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import { red } from '@mui/material/colors';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ShareIcon from '@mui/icons-material/Share';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddBoxTwoToneIcon from '@mui/icons-material/AddBoxTwoTone';

import axios from "axios";
import Modal from '@mui/material/Modal';

const config = require("../../../constants/constants.js")

const widthCard = 250;

const AdminConfigsElementCard = ({ imagePath, idx, pageId, nameImage, titleImage, subTitleImage, pageAll }) => {

  const url_iconaDelete = config.URL_IMAGES_CUSTOMER1 + "cestino.png";
  const url_iconaInfo = config.URL_IMAGES_CUSTOMER1 + "info.png";
  const help_iconaInfo = "titoli & info";
  const help_iconaDelete = "cancella";
  const url_elencoservizi = "/admin/configs/";

  let navigate = useNavigate();

  const [expanded, setExpanded] = React.useState(false);

  const [imageRemoved, setImageRemoved] = useState(false)

  const updatePageApiRequest = async (pageId, formInputs) => {
    const { data } = await axios.put(`/api/pages/admin/${pageId}`, { ...formInputs });
    return data;
  }

  const [updatePageResponseState, setUpdatePageResponseState] = useState({
    message: "",
    error: "",
  });
  
  const imageDeleteHandler = async (imagePath, idPage) => {

    console.log("[imageDeleteHandler] imagePath=",imagePath)
    console.log("[imageDeleteHandler] idPage=",idPage)

    let encoded = encodeURIComponent(imagePath)
    if (process.env.NODE_ENV !== "production") {
      await axios.delete(`/api/pages/admin/image/${encoded}/${idPage}`);
    } else {
      await axios.delete(`/api/pages/admin/image/${encoded}/${idPage}`);
    }
    // ricarico il tab, ma al momento ricarico con sempre attivo il tab 0
    window.location.assign('/admin/configs')
  }

  const saveTitlesHandler = async (imagePath, idPage) => {

    console.log("[saveTitlesHandler] idPage=",idPage)
    console.log("[saveTitlesHandler] pageAll=",pageAll)
    console.log("[saveTitlesHandler] titleImg=",titleImg)
    console.log("[saveTitlesHandler] subTitleImg=",subTitleImg)
    console.log("[saveTitlesHandler] titleImage=",titleImage)
    console.log("[saveTitlesHandler] subTitleImage=",subTitleImage)
    console.log("[saveTitlesHandler] idx=",idx)

    //const page =pageAll;
    
    console.log("[saveTitlesHandler] OLD page=",pageAll)

    pageAll.images.map((item, index) => {
        if(index === idx) {
            item.title=titleImg;
            item.subTitle=subTitleImg;
        }
    })

    console.log("[saveTitlesHandler] NEW page=",pageAll)

    const formInputsConfig = {
      images:pageAll.images
    }

    console.log('[handleSalva] formInputsConfig =', formInputsConfig);

      updatePageApiRequest(idPage, formInputsConfig)
        .then((data) => {
          if (data.message === "page updated") navigate("/admin/configs");
        })
        .catch((er) =>
          setUpdatePageResponseState({
            error: er.response.data.message
              ? er.response.data.message
              : er.response.data,
          })
        );

    setOpenModalInfo(false);
  }
   
  const closeTitlesHandler = async (imagePath, idPage) => {

    pageAll.images.map((item, index) => {
        if(index === idx) {
            setTitleImg(item.title);
            setSubTitleImg(item.subTitle);
        }
    })

    setOpenModalInfo(false);
  }

  console.log("[AdminConfigsElementCard] imagePath=",imagePath)
  console.log("[AdminConfigsElementCard] titleImage=",titleImage)
  console.log("[AdminConfigsElementCard] subTitleImage=",subTitleImage)
  console.log("[AdminConfigsElementCard] pageAll=",pageAll)

  const styleModalInfo = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };
  const [openModalInfo, setOpenModalInfo] = React.useState(false);
  const handleOpenModalInfo = () => setOpenModalInfo(true);
  const handleCloseModalInfo = () => setOpenModalInfo(false);

  const [titleImg, setTitleImg] = useState("");
  const [subTitleImg, setSubTitleImg] = useState("");

  function setTitleImage1(value) {
  }

  useEffect(() => {
    setTitleImg(titleImage);
    setSubTitleImg(subTitleImage);  
  console.log("[AdminConfigsElementCard useEffect] titleImage=",titleImage)
  console.log("[AdminConfigsElementCard useEffect] pageAll=",subTitleImage)
  }, [setTitleImg, setSubTitleImg])

 return (
    
    <Card
      sx={{
        width: widthCard,
        minWidth: widthCard,
        border: 1,
        borderColor: '#0c2b85',
        margin: 1,
        paddingTop: 2, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
        backgroundColor: '#ffffff',
        '&:hover': {
          backgroundColor: '#e9e9e9',
          opacity: [0.9, 0.8, 0.7],
        },
      }}
    >

    <Modal
        open={openModalInfo}
        onClose={handleCloseModalInfo}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModalInfo}>

            <Paper 
              variant="outlined" 
              square 
              sx={{
                p: { xs: 1, md: 1 },
                m: { xs: 0, md: 0 },
                textAlign: "center",
                backgroundColor: "#3788b0ff !important"
              }}
              >

              <Typography id="modal-modal-title" variant="h6" component="h2">
                Titoli immagine {idx+1}
              </Typography>

            </Paper>
          
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
          </Typography>

             <Stack
                sx={{ flexDirection: { xs: "column", md: "column" }, paddingTop: 0, paddingLeft: 0, paddingRight: 0, }}
              >

                <TextField id="id-title" label="titolo" variant="outlined" defaultValue={titleImage} 
                  sx={{
                    width: "43ch",
                    p: { xs: 1, md: 1 },
                    m: { xs: 1, md: 1 },
                  }}
                  onChange={(event) => {
                    setTitleImg(event.target.value);
                  }}
                />

                <TextField id="id-subtitle" label="sottotitolo" variant="outlined" defaultValue={subTitleImage} 
                  sx={{
                    width: "43ch",
                    p: { xs: 1, md: 1 },
                    m: { xs: 1, md: 1 },
                  }}
                  onChange={(event) => {
                    setSubTitleImg(event.target.value);
                  }}
                />

              </Stack>
                        
              <Stack
                sx={{ flexDirection: { xs: "row", md: "row",                         
                        alignItems: "center",
                        justifyContent: "center"
                }, 
                paddingTop: 0, paddingLeft: 0, paddingRight: 0, }}
              >

                <Button
                  type="button"
                  variant="contained"
                  color="warning"
                  onClick={() => {
                    closeTitlesHandler(imagePath, pageId);
                  }}
                  sx={{
                    width: "12ch",
                    p: 1,
                    m: 1,
                  }}
                >
                  Chiudi
                </Button>

                <Button
                  variant="contained"
                  type="submit"
                  color="success"
                  onClick={() => {
                    saveTitlesHandler(imagePath, pageId);
                  }}

                  sx={{
                    width: "12ch",
                    p: 1,
                    m: 1,
                  }}
                >
                  Salva
                </Button>

              </Stack>

        </Box>
      </Modal>

      <CardMedia
        component="img"
        image={imagePath ?? null}
        alt=""
        sx={{ width: widthCard - 32, paddingTop: 2, paddingBottom: 0, paddingLeft: 2, paddingRight: 2 }}
        onClick={() => {setOpenModalInfo(true)}}
      >
      </CardMedia>

      <CardContent>

        <Stack
          sx={{ flexDirection: { xs: "row", md: "row" }, 
                paddingTop: 0, paddingLeft: 0, paddingRight: 0, }}
        >

          <Tooltip title={help_iconaInfo} arrow placement="right-end">
            <Box
              component="img"
              paddingLeft={{ xs: 1, md: 1 }}
              paddingRight={{ xs: 1, md: 1 }}
              sx={{
                height: 25,
                width: 40,
                maxHeight: { xs: 25, md: 25 },
                maxWidth: { xs: 40, md: 40 },
              }}
              src={url_iconaInfo}
              onClick={() => {setOpenModalInfo(true)}}
            >
            </Box>
          </Tooltip>

          <Typography variant="body1"
            align="center"
            paddingLeft={{ xs: 1, md: 1 }}
            paddingRight={{ xs: 1, md: 1 }}
            sx={{
              fontFamily: 'Arial',
              fontWeight: 500,
              fontSize: 16,
              color: 'text.secondary',
              minWidth: { xs: 110, md: 110 },
            }}
          >
            immagine {idx + 1} 
          </Typography>

          <Tooltip title={help_iconaDelete} arrow placement="right-end">
            <Box
              component="img"
              paddingLeft={{ xs: 1, md: 1 }}
              paddingRight={{ xs: 1, md: 1 }}
              sx={{
                height: 25,
                width: 25,
                maxHeight: { xs: 25, md: 25 },
                maxWidth: { xs: 25, md: 25 },
              }}
              src={url_iconaDelete}
              onClick={() => {
                imageDeleteHandler(imagePath, pageId).then(data => setImageRemoved(!imageRemoved)) 
                navigate(url_elencoservizi)
              }}
            >
            </Box>
          </Tooltip>

        </Stack>
     
      </CardContent>

      <CardActions disableSpacing>

      </CardActions>

    </Card>

  );
};

export default AdminConfigsElementCard;
